import React, { useContext, useEffect, useState } from 'react'
import { useGridApiRef } from '@mui/x-data-grid-pro'
import { Button, Popconfirm } from 'antd'
import { CloseCircleOutlined, DeleteOutlined, EditOutlined, ExclamationCircleOutlined, PlusCircleOutlined } from '@ant-design/icons'
import api from '../../services/api'
import SL_Button from '../../components/buttons/Button'
import GeneralContext from '../../context/GeneralContext/GeneralContext'
import { SL_Grid } from '../../components/grid/SL_Grid'
import CreateScheduledNotification from './CreateScheduledNotification'
import EditScheduledNotification from './EditScheduledNotification'
import column_grid_scheduled_notification_list from '../grid_columns/column_grid_scheduled_notification_list'

export default function ListScheduledNotifications() {
    const gridRef = useGridApiRef()

    const [schedules, setSchedules] = useState([])
    const [currentSchedule, setCurrentSchedule] = useState(null)
    const [isModalCreateVisible, setIsModalCreateVisible] = useState(false)
    const [isModalEditVisible, setIsModalEditVisible] = useState(false)

    const {
        setShowLoading,
        mobile_mode,
    } = useContext(GeneralContext)

    useEffect(() => {
        loadSchedules()
    }, [])

    async function loadSchedules() {
        try {
            setShowLoading(true)
            const { data } = await api.scheduledNotifications.list()
            gridRef.current.setSelectionModel([])
            setSchedules(data)
            setCurrentSchedule(null)
        } catch (err) {
            console.log(err)
        } finally {
            setShowLoading(false)
        }
    }

    const handleRowChange = (e) => {
        setCurrentSchedule(e?.row ?? null)
    }

    const handleOnCloseModalCreate = async (reload) => {
        if (reload) await loadSchedules()
        setIsModalCreateVisible(false)
    }

    const handleOnCloseModalEdit = async (reload) => {
        if (reload) await loadSchedules()
        setIsModalEditVisible(false)
    }

    const handleDelete = async () => {
        if (!currentSchedule) return
        setShowLoading(true)
        try {
            await api.scheduledNotifications.remove(currentSchedule.id)
            await loadSchedules()
        } finally {
            setShowLoading(false)
        }
    }

    return (
        <>
            {isModalCreateVisible && (
                <CreateScheduledNotification handleOnCloseModal={handleOnCloseModalCreate} />
            )}

            {isModalEditVisible && currentSchedule && (
                <EditScheduledNotification
                    schedule={currentSchedule}
                    handleOnCloseModal={handleOnCloseModalEdit}
                />
            )}

            <div className="flex flex-col flex-1 h-full">
                <div className={`flex w-full bg-fit-red-700 p-2 rounded-tl-[4px] rounded-tr-[4px] flex-wrap ${mobile_mode ? 'flex-col items-center gap-4' : 'gap-2'}`}>
                    <div className='self-center text-white font-semibold text-base'>
                        Notificações Agendadas
                    </div>

                    <div className={`flex-1 flex flex-wrap gap-2 justify-end`}>

                        <SL_Button
                            type='default'
                            className={`flex items-center flex-1 ${mobile_mode ? 'w-[200px]' : 'max-w-[220px]'}`}
                            onClick={() => setIsModalCreateVisible(true)}
                            icon={<PlusCircleOutlined className='text-base flex items-center' />}
                        >
                            <span className='text-fit-red-800 font-semibold flex-1'>
                                Novo Agendamento
                            </span>
                        </SL_Button>

                        <SL_Button
                            type='default'
                            className={`flex items-center flex-1 ${mobile_mode ? 'w-[200px]' : 'max-w-[200px]'}`}
                            onClick={() => setIsModalEditVisible(true)}
                            disabled={!currentSchedule}
                            icon={<EditOutlined className='text-base flex items-center' />}
                        >
                            <span className='text-fit-red-800 font-semibold flex-1'>
                                Editar
                            </span>
                        </SL_Button>

                        <Popconfirm
                            placement="bottomRight"
                            title="Deseja excluir este agendamento?"
                            onConfirm={handleDelete}
                            disabled={!currentSchedule}
                            icon={<ExclamationCircleOutlined style={{ color: 'red' }} />}
                        >
                            <SL_Button
                                type='default'
                                className={`flex items-center flex-1 ${mobile_mode ? 'w-[200px]' : 'max-w-[160px]'}`}
                                disabled={!currentSchedule}
                                icon={<DeleteOutlined className='text-base flex items-center' />}
                            >
                                <span className='text-fit-red-800 font-semibold flex-1'>
                                    Excluir
                                </span>
                            </SL_Button>
                        </Popconfirm>

                    </div>
                </div>

                <div className={`w-full flex-1 min-h-[400px] smb:min-h-0`}>
                    <SL_Grid
                        rows={schedules ?? []}
                        apiRef={gridRef}
                        columns={column_grid_scheduled_notification_list}
                        onRowClick={handleRowChange}
                    />
                </div>
            </div>
        </>
    )
}
